import React, { useState } from 'react'
import { Form, Input, Button, Checkbox, message, PageHeader, Row } from 'antd';
import { FetchVariable } from '../../Components/FetchVariable/FetchVariable';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { useAuth } from '../../Components/ProtectedRoute/ProtectedRoute'

function Login() {
  
    const [user, setUser] = useState('')
    const [employeePhoto, setEmployeePhoto] = useState('')

    const auth = useAuth(user)
    const photo = useAuth(employeePhoto)

    auth.login(user)
    photo.photo(employeePhoto)

    const navigate = useNavigate();

    function onFinish(value){

    async function axiosPostLogin(){

        const payload = {
        EmployeeEmail: value.email,
        EmployeePassword: value.password
        }
        if(payload){
        await axios.post(`${FetchVariable.Heroku}/employee/login`, payload)
        .then(function(response){
            let employeePhoto = response.data.EmployeePhoto
            let employeeAuth = response.data.EmployeeAdmin
            let employeeName = response.data.EmployeeName
            setEmployeePhoto(employeePhoto)
            setUser(employeeName)
            return employeeAuth
        }).then(employeeAuth => {
            if (employeeAuth === true){
                navigate('/DashBoard')
            }
            else if (employeeAuth === false){
                onFinishFailed('You do not have admin privileges')
            }
            else{
                onFinishFailed('The user name or the password is not correct')
            }
            })
            }
        }
        axiosPostLogin();
    };

  const onFinishFailed = (errorInfo) => {
    message.error(errorInfo)
  };

  return (
    <div>
    <PageHeader
        className='site-page-header'
        onBack={()=> navigate('/')}
        title="Back"
        subTitle="Back to the Home page" 
    />
    <Row justify='center' className='h2' style={{marginTop:'200px', marginBottom:'50px'}} >
        Sign In
    </Row>
    <Form
      name="basic"
      labelCol={{
        span: 10,
      }}
      wrapperCol={{
        span: 6,
      }}
      initialValues={{
        remember: false,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Form.Item
        label="Email"
        name="email"
        rules={[
          {
            required: true,
            message: 'Please input your email!',
          },
        ]}
      >
        <Input placeholder='Enter: example@domain.com' />
      </Form.Item>

      <Form.Item
        label="Password"
        name="password"
        rules={[
          {
            required: true,
            message: 'Please input your password!',
          },
        ]}
      >
        <Input.Password placeholder='Enter: examplepass'/>
      </Form.Item>

      <Form.Item
        name="remember"
        valuePropName="checked"
        wrapperCol={{
          offset: 10,
          span: 16,
        }}
      >
        <Checkbox>Remember me</Checkbox>
      </Form.Item>
      <Form.Item
        wrapperCol={{
          offset: 10,
          span: 16,
        }}
      >
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
    </div>
  );
};

export default Login